module.exports = __webpack_public_path__ + "img/statistic-unfollowl.90501a1f.svg";